import React from "react";
import { Link } from "react-router-dom";

const BannerOne = () => {
  return (
    <section className="banner-area banner-bg">
      {/* Decorative floating handyman tool icons (bg layer) */}
      <div className="hero-tools" aria-hidden="true">
        <svg className="hero-tools__icon hero-tools__icon--a" viewBox="0 0 24 24" fill="none">
          <path d="M14 3a5 5 0 0 1-5 5H6l-3 3 5 5 3-3v-3a5 5 0 0 1 5-5l4-4-2-2-4 4Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round"/>
        </svg>
        <svg className="hero-tools__icon hero-tools__icon--b" viewBox="0 0 24 24" fill="none">
          <path d="M4 14 14 4l6 6L10 20l-6-6Zm10-10 6 6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round"/>
        </svg>
        <svg className="hero-tools__icon hero-tools__icon--c" viewBox="0 0 24 24" fill="none">
          <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round"/>
        </svg>
        <svg className="hero-tools__icon hero-tools__icon--d" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/>
          <path d="M8 12h8M12 8v8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
        </svg>
      </div>

      <div className="container">
        <div className="row justify-content-start">
          <div className="col-lg-7">
            <div className="banner-content">
              <span className="sub-title wow fadeInUp" data-wow-delay=".2s">
                Handyman Services in Kuala Lumpur & Malaysia
              </span>

              <h1 className="title wow fadeInUp" data-wow-delay=".4s">
                Trusted Handyman & Home Renovation Services in Malaysia
              </h1>

              <p className="wow fadeInUp" data-wow-delay=".6s">
                Looking for a reliable handyman near you? FRG Renovation Works delivers professional handyman services, home repair, and full home renovation across Kuala Lumpur, Selangor and Malaysia. From kitchen renovation and bathroom remodeling to emergency handyman services and licensed home maintenance — our expert team handles every job with quality craftsmanship you can trust.
              </p>

              <div className="banner-btn">
                <Link
                  to="/services"
                  className="btn btn-two wow fadeInRight"
                  data-wow-delay=".8s"
                >
                  Our service
                </Link>
              </div>

              {/* Engaging cycling specialty rotator */}
              <div className="hero-rotator" aria-hidden="true">
                <span className="hero-rotator__prefix">We fix</span>
                <div className="hero-rotator__stage">
                  <ul className="hero-rotator__list">
                    <li>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M14 3a5 5 0 0 1-5 5H6l-3 3 5 5 3-3v-3a5 5 0 0 1 5-5l4-4-2-2-4 4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round"/>
                      </svg>
                      Home Renovation
                    </li>
                    <li>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round"/>
                      </svg>
                      Electrical Work
                    </li>
                    <li>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M6 3v6a6 6 0 0 0 6 6v6M12 3v18M18 3v6a6 6 0 0 1-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                      </svg>
                      Plumbing Repair
                    </li>
                    <li>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M4 20 12 4l2 2-8 16-2-2ZM14 6l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      Painting & Finishes
                    </li>
                    <li>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M3 12h18M5 8h14M5 16h14M9 4v16M15 4v16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                      </svg>
                      Kitchen Remodeling
                    </li>
                    <li>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2v2M4.93 4.93l1.41 1.41M2 12h2M6.34 17.66l-1.41 1.41M12 20v2M19.07 19.07l-1.41-1.41M22 12h-2M17.66 6.34l1.41-1.41" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8"/>
                      </svg>
                      Emergency Repairs
                    </li>
                  </ul>
                </div>
              </div>

              {/* Floating trivia card */}
              <div className="hero-trivia" aria-hidden="true">
                <div className="hero-trivia__icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
                    <path d="M12 7v6M12 16.5v.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="hero-trivia__body">
                  <span className="hero-trivia__label">Did you know?</span>
                  <div className="hero-trivia__stage">
                    <ul className="hero-trivia__list">
                      <li>A leaking tap wastes up to 20,000 litres of water a year.</li>
                      <li>Regular home maintenance can cut repair costs by 40%.</li>
                      <li>A fresh coat of paint can boost property value by up to 5%.</li>
                      <li>Most electrical faults are fixed within the first hour on-site.</li>
                      <li>A well-maintained HVAC system uses 15% less energy.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerOne;
